import React from 'react';
import { Spin } from 'antd';
import PropTypes from 'prop-types';
import { KRZIcon } from '../static/img/KRZIcon';

function KRZSpinner({ size = 40 }) {
  return (
    <Spin
      indicator={
        <KRZIcon
          size={size}
          color="#931B34" // or any color you want
        />
      }
    />
  );
}

export default KRZSpinner;

KRZSpinner.propTypes = {
  size: PropTypes.number,
};
